/** @module components/cloze-quiz */


import Model from '@lernetz/ts-lib/src/core/model/Model';
import View from '@lernetz/ts-lib/src/core/view/View';

import {Span} from './Span';

import {TextSpan as template} from '../../templates/cloze-quiz';


/**
 * Specifies the initial state for a [[TextSpan]].
 */
export interface TextSpanInitialState {

    /**
     * Sets the text that should be displayed for this text span.
     */
    text: string;
}


/**
 * A text span in a cloze quiz [[Paragraph]].
 */
export class TextSpan extends Model implements Span {

    /**
     * Initializes a new instance of the [[TextSpan]] class.
     *
     * @param initialState Specifies the initial state for the new instance.
     * @param data An optional arbitrary object that gets forwarded to [[Model]]'s constructor.
     */
    constructor(initialState: TextSpanInitialState, data: object = {}) {
        super({
            text: '',
            ...initialState,
            ...data
        });
    }

    /**
     * Gets the text that is displayed for this span.
     */
    public readonly text: string;
}


/**
 * Base `View` class to render a [[TextSpan]].
 * Subclass this type if you want to use a different template.
 */
export class TextSpanView extends View<TextSpan> {

    public constructor() {
        super({ template });
    }
}
